import { RouteConfig, SideLink } from '@/types/utility.types'
import { IconExchange, IconCurrencyPound } from '@tabler/icons-react'

export const currencyModuleKey = 'currency'

const currencyRateRoute: RouteConfig = {
  uid: currencyModuleKey,
  path: 'currency-rate',
  type: 'list',
  lazy: async () => ({
    Component: (await import('@/pages/currency')).default,
  }),
}

export const sidelink: SideLink = {
  title: 'Currency',
  href: '',
  icon: <IconCurrencyPound size={18} />,
  order: 8,
  sub: [
    {
      uid: currencyModuleKey,
      title: 'Currency Rates',
      href: '/currency-rate',
      icon: <IconExchange size={18} />,
      order: 1,
    },
  ],
}
export default currencyRateRoute
